module.exports = __webpack_public_path__ + "static/highlight-pattern2-b3fb9842932177ae850279cf382afd16.svg";